var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-content px-4 px-lg-0 px-lx-0"
  }, [_vm.subHeaderTitleText ? _c('div', {
    staticClass: "w-100 sub-header-title-text",
    class: _vm.subHeaderTitleTextClass
  }, [_vm._v(" " + _vm._s(_vm.subHeaderTitleText) + " ")]) : _vm._e(), _c('div', {
    staticClass: "w-100 title-text py-3",
    class: _vm.titleTextClass
  }, [_vm._v(" " + _vm._s(_vm.titleText) + " ")]), _c('div', {
    staticClass: "w-100 sub-title-text",
    class: _vm.subTitleTextClass,
    domProps: {
      "innerHTML": _vm._s(_vm.subTitleText)
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }